import { defineComponent, resolveDirective, openBlock, createElementBlock, createElementVNode, withDirectives, createVNode, unref, createTextVNode, toDisplayString, Fragment, renderList, createBlock } from "@histoire/vendors/vue";
import { Icon } from "@histoire/vendors/iconify";
import "./ControlsComponentPropItem.js";
import _sfc_main$1 from "./ControlsComponentPropItem.vue_vue_type_script_setup_true_lang.js";
const _hoisted_1 = { class: "htw-font-mono htw-p-2 htw-flex htw-items-center htw-gap-1" };
const _hoisted_2 = /* @__PURE__ */ createElementVNode("span", { class: "htw-opacity-30" }, "<", -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("span", { class: "htw-opacity-30" }, ">", -1);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ControlsComponentProps",
  props: {
    variant: null,
    definition: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _directive_tooltip = resolveDirective("tooltip");
      return openBlock(), createElementBlock("div", null, [
        createElementVNode("div", _hoisted_1, [
          withDirectives(createVNode(unref(Icon), {
            icon: "carbon:flash",
            class: "htw-w-4 htw-h-4 htw-text-primary-500 htw-flex-none"
          }, null, 512), [
            [_directive_tooltip, "Auto-detected props"]
          ]),
          createElementVNode("div", null, [
            _hoisted_2,
            createTextVNode(toDisplayString(__props.definition.name), 1),
            _hoisted_3
          ])
        ]),
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.definition.props, (prop) => {
          return openBlock(), createBlock(_sfc_main$1, {
            key: prop.name,
            variant: __props.variant,
            component: __props.definition,
            definition: prop
          }, null, 8, ["variant", "component", "definition"]);
        }), 128))
      ]);
    };
  }
});
export {
  _sfc_main as default
};
